import React from 'react';
import config from '../../../../config';
import NumberFilter from '@inovua/reactdatagrid-community/NumberFilter';
import * as Yup from 'yup';
import Header from '../../../components/Header/Header';
import Toolbar from '../../../components/Toolbar/Toolbar';
import Table from '../../../components/Table/Table';
import NavBar from '../../../components/NavBar/NavBar';
import BoolFilter from '@inovua/reactdatagrid-community/BoolFilter';
import { Switch } from '@mui/material';
import { useTranslation } from 'react-i18next';

const InternalDistributor = () => {
  const urls = {
    list: config.INTERNAL_DISTRIBUTOR,
    create: config.INTERNAL_DISTRIBUTOR,
    update: config.INTERNAL_DISTRIBUTOR_WITH_ID,
    delete: config.INTERNAL_DISTRIBUTOR_WITH_ID
  };
  const resource = 'PROMO_DISTRIBUTOR';
  const { t } = useTranslation();

  const columns = [
    {
      header: t('id'),
      name: 'internalDistributorId',
      type: 'number',
      filterEditor: NumberFilter
    },
    {
      header: t('name'),
      name: 'name',
      type: 'string',
      validationSchema: Yup.string().max(255).required('Name is required'),
      isEditable: true,
      required: true,
      defaultFlex: 1
    },
    {
      header: t('surname'),
      type: 'string',
      validationSchema: Yup.string().max(255).required('Surname is required'),
      isEditable: true,
      required: true,
      name: 'surname'
    },
    {
      header: t('description'),
      type: 'string',
      validationSchema: Yup.string().max(255).required('Description is required'),
      isEditable: true,
      required: true,
      name: 'description'
    },
    {
      header: t('email'),
      type: 'string',
      validationSchema: Yup.string().email().required('Email is required'),
      isEditable: true,
      required: true,
      name: 'email'
    },
    {
      header: t('is.active'),
      name: 'isActive',
      type: 'boolean',
      isEditable: true,
      filterEditor: BoolFilter,
      render: ({ value }) => <Switch disabled checked={value} />
    }
  ];

  return (
    <>
      <Header title={t('internal.distributors')} />
      <Toolbar iamResource={resource} />
      <Table
        iamResource={resource}
        uniqueId={'internalDistributorId'}
        tableId={'internalDistributorId'}
        columns={columns}
        urls={urls}
      />
      <NavBar />
    </>
  );
};

export default InternalDistributor;
